import React from "react";
import { Card, Layout, SkeletonBodyText, SkeletonPage } from "@shopify/polaris";

export function SuppliersIndexPageSkeleton(): React.JSX.Element {
  return (
    <SkeletonPage primaryAction>
      <Layout>
        <Layout.Section>
          <Card>
            <SkeletonBodyText lines={5} />
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
